import { makeStyles } from '@material-ui/core'
import React from 'react'

import { Select, mapToOptions } from 'src/modules/ui'

import { usePurchasing } from '../hooks'

const useStyles = makeStyles(theme => ({
  label: {
    maxWidth: 80,
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    [theme.breakpoints.up('mobile')]: {
      maxWidth: 120,
    },
    [theme.breakpoints.up('tablet')]: {
      maxWidth: 200,
    },
  },
}))

const EnvironmentSelector = () => {
  const classes = useStyles()
  const {
    purchasingEnvironment,
    purchasingEnvironments,
    setPurchasingEnvironment,
  } = usePurchasing()

  const handleChangeEnvironment = event => {
    const { value } = event.target
    console.info('handleChangeEnvironment', value)
    setPurchasingEnvironment(value)
  }

  return (
    <Select
      allowNoValue={false}
      color="white"
      labelClassName={classes.label}
      onChange={handleChangeEnvironment}
      options={purchasingEnvironments.map(mapToOptions)}
      value={purchasingEnvironment}
      variant="outlined"
    />
  )
}

export default EnvironmentSelector
